<template>
  <div>
    <PrintPdf
        v-if=" partialDeliveries.length === 1"
        :filename="'einraeumliste_'+$moment.unix(partialDeliveries[0].date).format('DD-MM-YYYY')+'_'+partialDeliveries[0].id+'.pdf'"
        :uri="`warehouse/packing-list/${partialDeliveries[0].id}`"
        @loading="updateLoading"
    >
      <template v-slot:default="{ eventHandlers, loading }">
        <div v-on="eventHandlers" class="hover-link text-center" style="width: 80px;">
          <v-progress-circular
              v-if="loadingPdf"
              indeterminate
              color="primary"
              size="35"
              class="mb-2 text-center"
          />
          <div class="icon-drucken text-center mb-2" style="font-size: 35px;" v-if="!loadingPdf"></div>
          <div style="font-size: 14px">Einräumliste</div>
        </div>
      </template>
    </PrintPdf>
    <div v-if="partialDeliveries.length > 1">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div
              v-on="on"
              v-bind="attrs"
              class="hover-link text-center"
              style="width: 80px;"
          >
            <v-progress-circular
                v-if="loadingPdf"
                indeterminate
                color="primary"
                size="35"
                class="mb-2 text-center"
            />
            <div class="icon-drucken text-center mb-2" style="font-size: 35px;" v-if="!loadingPdf"></div>
            <div style="font-size: 14px">Einräumliste</div>
          </div>
        </template>

        <v-list>
          <v-list-item
              v-for="partialDelivery in partialDeliveries"
              :key="partialDelivery.id"
              class="v-list-item--link"
          >
            <PrintPdf
                :filename="'einraeumliste_'+$moment.unix(partialDelivery.date).format('DD-MM-YYYY')+'_'+partialDelivery.id+'.pdf'"
                :uri="`warehouse/packing-list/${partialDelivery.id}`"
                @loading="updateLoading"
            >
              <template v-slot:default="{ eventHandlers, loading }">
                        <span v-on="eventHandlers">
                          {{ $moment.unix(partialDelivery.date).format('DD.MM.YYYY HH:mm') }}
                        </span>
              </template>
            </PrintPdf>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import {mapGetters} from "vuex";
import DirectOrderSwtich from "@/components/SmartLogistics/Order/DirectOrderSwitch.vue";
import DirectOrderSwitch from "@/components/SmartLogistics/Order/DirectOrderSwitch.vue";
import PrintPdf from "@/components/SmartLogistics/Print/PrintPdf.vue";

export default {
  name: 'PrintClearingListButton',
  components: {PrintPdf},

  props: {
    partialDeliveries: {
      type: Array,
      required: true
    },
  },

  data() {
    return {
      loadingPdf: false
    }
  },

  computed: {
    ...mapGetters({
      basket: 'smartLogisticBasket/basket',
      orderLockOffset: 'smartLogisticSettings/orderLockOffset',
      isDirectOrder: 'smartLogisticSettings/isDirectOrder',
      currentLivingUnit: 'smartLogisticSettings/currentLivingUnitPanel',
      suggestionsLoading: 'smartLogisticOrderSuggestion/isLoading',
      orderSuggestion: 'smartLogisticOrderSuggestion/chosenDateObject',
      directOrderBasketArticles: 'smartLogisticDirectOrder/BasketArticles',
    }),
  },

  methods: {
    updateLoading(value) {
      this.loadingPdf = value
    },
  }
}
</script>
